import { isSameDay } from 'date-fns';

export const isJSON = (str: string) => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

// The loan quote serializes due dates as DateTime ("2026-08-30T00:00:00") while the
// outstanding balance breakdown serializes them as DateOnly ("2026-08-30"), so the two
// sources must be reconciled by calendar day rather than by raw string equality.
export const isSameDueDate = (left: string, right: string) => {
  if (!left || !right) return false;

  const leftDate = new Date(left);
  const rightDate = new Date(right);

  if (isNaN(leftDate.getTime()) || isNaN(rightDate.getTime())) return false;

  return isSameDay(leftDate, rightDate);
};
